import { gameIconSvg } from '../components/GameIcon';
import { motionOff } from '../components/ui';

const COIN = gameIconSvg('coin', 28) ?? '';

/**
 * Coins fly from `from` (the claim button) into the coin counter (marked `data-coin-target`), which pops
 * as they land. Plain DOM and the Web Animations API (transform and opacity only), removed when done.
 * With motion off, or no counter on screen, the counter just pops.
 */
export function flyCoins(from: Element | null, count = 8): void {
  const target = document.querySelector<HTMLElement>('[data-coin-target]');
  const pop = () => target?.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 260, easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)' });
  if (!from || !target || motionOff() || typeof document.body.animate !== 'function') {
    pop();
    return;
  }
  const a = from.getBoundingClientRect();
  const b = target.getBoundingClientRect();
  const x0 = a.left + a.width / 2;
  const y0 = a.top + a.height / 2;
  const x1 = b.left + 10;
  const y1 = b.top + b.height / 2;
  for (let i = 0; i < count; i++) {
    const el = document.createElement('div');
    el.setAttribute('aria-hidden', 'true');
    el.style.cssText = `position:fixed;left:${x0 - 14}px;top:${y0 - 14}px;width:28px;height:28px;z-index:90;pointer-events:none;will-change:transform,opacity`;
    el.innerHTML = COIN;
    document.body.appendChild(el);
    // Each coin bursts out a little, then arcs to the counter.
    const sx = (Math.random() - 0.5) * 120;
    const sy = -30 - Math.random() * 60;
    const dx = x1 - x0;
    const dy = y1 - y0;
    const anim = el.animate(
      [
        { transform: 'translate(0, 0) scale(0.4)', opacity: 0 },
        { transform: `translate(${sx}px, ${sy}px) scale(1.1)`, opacity: 1, offset: 0.3 },
        { transform: `translate(${dx}px, ${dy}px) scale(0.6)`, opacity: 0.9 },
      ],
      { duration: 720, delay: i * 45, easing: 'cubic-bezier(0.55, 0, 0.35, 1)', fill: 'both' },
    );
    anim.onfinish = () => {
      el.remove();
      pop();
    };
  }
}
